import * as React from "react";
import { forwardRef } from "react";
const SvgCancelOutgoingIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Check Icon/Cross" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M12.1496 5.84961L5.84961 12.1496M12.1496 12.1496L5.84961 5.84961L12.1496 12.1496Z", stroke: "#6192BE", strokeWidth: 1.4, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgCancelOutgoingIcon);
export { ForwardRef as ReactComponent };
